<template>
  <transition name="slide-up">
  <div id="Message" v-if="message.message">
      <div class="Message">
        <div class="messageMessage" v-html="message.message"></div>
        <button class="closeMessage subtleButton" @click="closeMessage(message.onClose)">Close</button>
      </div>
  </div>
  </transition>
</template>

<script>
import {store} from '@/store'

export default {
  name: 'Message',
  computed: {
    message () {
      return store.state.message
    }
  },
  methods: {
    closeMessage (onClose) {
      store.commit('resetMessage', {
        message: false
      })
      if (onClose) {
        if (onClose === 'noinstall') {
          localStorage.standAloneDate = Date.now()
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/variables/variables';

  #Message {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: $brandBrightGreen;
    color: white;
  }
  .messageMessage {
    margin: 15px auto;
    padding: 0 50px;
  }
  .closeMessage {
    position: absolute;
    bottom: 0;
    margin-bottom: 15px;
    right: 0;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/Message.vue